import { PROD_API } from "./api";

export const NEWS = {
   newBooks: 'newBooks',
   newDirectionShow: 'newDirectionShow',
}

export const API_NEWS = `${PROD_API}/api/news/`;
